import { Injectable } from '@angular/core';

import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as bannerActions from '../banner/banner.actions';

import { SoledadBannerService } from '../../shared/services/b2b/banner.service';

// Rxjs
import { Observable } from 'rxjs';

import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class BannerEffects {
    constructor(private bannersService: SoledadBannerService, private actions$: Actions) {}

    getBanners$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(bannerActions.DO_GET_HEADERS),
            switchMap((action: bannerActions.DoGetHeaders) =>
                this.bannersService.getBannersHeaders().pipe(
                    map((data) => new bannerActions.DoGetHeadersOK(data)),
                    catchError((error) => of(new bannerActions.DoGetHeadersKO(error)))
                )
            )
        )
    );
}
